import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-raw-html-viewer',
  standalone: true,
  imports: [],
  templateUrl: './raw-html-viewer.component.html',
  styleUrl: './raw-html-viewer.component.scss'
})
export class RawHtmlViewerComponent implements OnChanges {
  @Input({ required: true }) rawText?: string = '';
  html: SafeHtml = '';

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['rawText']?.currentValue && this.rawText) {
      this.html = this.domSanitizer.bypassSecurityTrustHtml(this.rawText?.replace(/\n/g, '<br>'));
    }
  }
}
